<template>
  <div class="login-wrapper">
    <div class='content'>
      <div class="logo">
        <img src="@/assets/images/logo-ht.png" />
      </div>
      <van-cell-group>
        <van-field v-validate="rules.account" v-model.trim="account" name="account" @input='changeAccount' placeholder="请输入手机号/Email" :error-message="errors.first('account')" autocomplete="off" clearable />
        <van-field v-model.trim="imageCode" name="imageCode" placeholder="图形验证码" autocomplete="off" clearable>
          <div slot="button" class="tCode pointer" v-loading="codeLoading" :style="{background: `url(${tCode}) center center / cover no-repeat`}" @click="changeTCode"></div>
        </van-field>
        <van-field v-validate="rules.code" v-model.trim="code" name="code" placeholder="验证码" :error-message="errors.first('code')" autocomplete="off" clearable>
          <vericode slot='button' :send-code='sendCode' :disable='imageCode.length !== 4' @send-code='handleSendCode'></vericode>
        </van-field>
        <van-field v-validate="rules.password" v-model.trim="password" name="password" type="password" placeholder="请输入6-20位字母数字组成密码" :error-message="errors.first('password')" autocomplete="off" clearable />
        <div class="tip">注册默认同意
          <!-- <a @click="$router.push({path:'/register-protocol'})">正雅用户注册协议</a> -->
          <a @click="$router.push({path:'/privacy-protocol'})">隐私政策</a>
        </div>
        <van-button round type="primary" size="large" :disabled="saveDisabled" @click="handleRegister">注册</van-button>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5';
import Vericode from "@/components/member/vericode";
import { Toast } from "vant";
export default {
  data () {
    return {
      imageCode: '',
      isMobile: false,
      vCode: '',
      codeLoading: false,
      tCode: '',
      guid: '',
      phone: '',
      account: '',
      code: '',
      password: '',
      sendCode: false,
      disable: true,
      saveDisabled: false,
      scode: false,
      rules: {
        account: { required: true, formatAccount: true },
        code: { required: true, formatCode: true },
        password: { required: true, formatPassword: true }
      }
    }
  },
  watch: {
    scode: {
      handler (val, oldVal) {
        this.sendCode = val
      }
    }
  },
  methods: {
    changeAccount (val) {
      this.isMobile = val && !(val.indexOf('@') > -1) && !isNaN(val) && val.length === 11
      if (this.isMobile) {
        this.vCode = localStorage.getItem('VCode')
        this.guid = this.getGuid()
        this.tCode = this.vCode + 'imageid=' + this.guid
      }
    },

    changeTCode () {
      this.codeLoading = true
      this.tCode = this.vCode + 'imageid=' + this.guid + '&t=' + (new Date ()).getTime()
      this.codeLoading = false
    },

    getGuid () {
      function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }
      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },

    handleRegister () {
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '正在注册...',
            overlay: true
          });
          this.saveDisabled = true;
          let params = {
            AppID: this.GLOBAL.AppID, // 应用号
            Method: 'Register', // 接口名称
            Account: this.account, // 帐号
            Code: this.code,
            Password: this.password,
          }
          this.$Request(params).then(res => {
            if (res.UserRegisterID !== '') {
              Toast.clear();
              Toast.loading({
                type: "success",
                overlay: false,
                message: "注册成功",
                duration: 1000
              });
              setTimeout(() => {
                this.saveDisabled = false;
                this.$router.push({
                  path: '/'
                })
              }, 1000)
            }
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }
      });
    },
    handleSendCode () {
      this.scode = true
      let params = {
        AppID: this.GLOBAL.AppID,//应用号:3:Erp2,12:在线提交3
        Method: 'GetVerifyCode',
        Account: this.account,//帐号:maxlength:100
        Type: 1,//验证码类型:1:注册,2:需要登录修改密码,3:无需登录修改密码,4:修改用户帐号 
        ImageID: this.isMobile ? this.guid : '',//图片编号:Type==1必填,Type==3必填
        ImageCode: this.isMobile ? this.imageCode : ''//图片验证码:Type==1必填,Type==3必填 
      }
      this.$Request(params)
    },
    handleInput () {
      this.$validator.validate('account').then(result => {
        if (result) {
          // this.vCode = Cookies.get('VCode')
          // this.guid = this.getGuid()
          // this.tCode = this.vCode + 'imageid=' + this.guid
          this.disable = false
        }
      })
    },
    //自定义字段验证
    validateField () {
      this.$validator.extend('formatAccount', {
        getMessage: field => "请输入正确的手机号或Email",
        validate: (value) => {
          return /^1\d{10}$/.test(value) || /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-z0-9_-]+)+$/.test(value)
        }
      });
      this.$validator.extend('formatCode', {
        getMessage: field => "请输入6位验证码",
        validate: (value) => {
          return /^([0-9]{6})$/.test(value)
        }
      });
      this.$validator.extend('formatPassword', {
        getMessage: field => "请输入6-20位字母数字组成密码",
        validate: (value) => {
          return /^([a-zA-Z0-9]{6,20})$/.test(value)
        }
      });
    }
  },
  mounted () {
    this.validateField();
  },
  components: {
    Vericode
  }
}
</script>
<style lang="less" scoped>
.tCode {
  width: 160px;
  height: 60px;
}

.pointer {
  cursor: pointer;
}

.login-wrapper {
  .logo {
    margin: 220px auto 100px auto;
    text-align: center;
    img {
      width: 400px;
    }
  }
  .content {
    padding: 0 40px;
  }
  .van-cell-group {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
      border-top: none;
    }
    .van-button--primary {
      background: #269cca;
      border-color: #269cca;
      margin: 20px 0;
    }
  }
  .tip {
    font-size: 28px;
    margin: 40px 10px;
    a {
      color: #269cca;
      padding: 0 10px;
    }
  }
  .forget-pwd {
    text-align: right;
  }
  .register-link {
    text-align: center;
  }
  /deep/ .van-icon-clear {
    font-size: 36px;
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/member/register.vue